<!-- MNDNR Logo -->
<img src="assets/images/main_banner_logo.jpg" width="100%" alt="Minnesota DNR logo on top of photo of lake and dock" />

<!-- Application Title -->
 <h2 mat-dialog-title style="font-weight:bold; color:#003865">Lake & Flood Elevations Online</h2>

<!-- About dialog -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <p>The Lake & Flood Elevations Online (LFEO) viewer is a web-based interactive map tool for users to view flood elevations for lakes and other basins in Minnesota.</p>

    <p>Not all lakes and basins have flood elevations determined. Information available to the public is only shown if it is based on current effective FEMA flood studies or other sources determined by Minnesota DNR (MNDNR) to be best available data that meets minimum quality standards.</p>

    <p>*Local ordinances use higher flood elevations than shown in this application. State minimum elevation requirements for new/expanded structures add at least one foot to the 100-year flood elevation. Local ordinances may be more restrictive than state minimums. Consult your local zoning authority – your city, if within city limits, or your county or township if outside city limits – to ensure you comply with local requirements.</p>

    <p>We strive to have this resource as complete and accurate as possible. If you have questions, see errors, or are aware of data that should be available in this online viewer, please contact <a href="mailto:floodplain.dnr@state.mn.us">Minnesota DNR Floodplain Program staff</a>.</p>

    <br />

    <p style="color:#4b4b4b;"><i><strong>Disclaimer:</strong> The State of Minnesota, Department of Natural Resources, Ecological and Water Resources Division assumes no responsibility for and disclaims all liability for any typographical or other errors on this site. The DNR may make changes to the lake floodplain elevations at any time and without notice.</i></p>

</mat-dialog-content>

<!-- Close button -->
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>Continue</button>
</mat-dialog-actions>
